import { getErrorss } from "../../../functions/errors/GetErrors"
import { getQueryUnits } from "../../../functions/shared/api/queries/getQueryUnits"
import { ACCESS_KEY, urlAPI } from "../../../urls"
import { dataFetchingFinish, dataFetchingStart } from "../../slices/modalSlice"
import { type AppDispatch, type RootState } from "../../store"
import {  sendUnitNotification, singleUnitFetchingSuccess } from "../unitsActions"
import { fetchUser } from "../userActions"
import { fetchUnits } from "./fetchUnits"



export const promoteAgentUnit = (unitID: number ) => async (dispatch: AppDispatch, getState: () => RootState): Promise<any> => {
    const jwt = window.localStorage.getItem(ACCESS_KEY) ?? ''
    try {
        dispatch(dataFetchingStart())
        const unit = getState().units.units.find(unitItem => unitItem.id === unitID)
        const Statuses = (unit?.attributes?.Statuses ?? []).filter(status => status !== 'Drafted')

        const bodyObject = {
            method: 'PUT',
            collection: 'units',
            id: unitID,
            body: {
                Statuses : ['Door close']
            },
            query: getQueryUnits()
        }
        const response = await fetch(`${urlAPI}`, {
            method: 'POST',
            body: JSON.stringify(bodyObject),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwt}`
            }
        })
        const responseJSON = await response.json() as unknown as any


        if (responseJSON.success) {
            if (responseJSON.response.error != null) {
                dispatch(dataFetchingFinish())
                return { textNavigate: '', isSuccessful: false, textNotification: getErrorss(responseJSON) }
            } else {     
                const { isSuccessful } = dispatch(singleUnitFetchingSuccess(responseJSON))
                if (!isSuccessful) {
                    await dispatch(fetchUnits(true))
                    await dispatch(fetchUser(true))
                }
                void sendUnitNotification(responseJSON.response.data, 'user-unit-new')
                dispatch(dataFetchingFinish())
                return {
                    textNavigate: ``,
                    isSuccessful: true,
                    textNotification: 'Unit has been published successfully'
                }
            }
        } else {
            dispatch(dataFetchingFinish())
            return { textNavigate: '', isSuccessful: false, textNotification: getErrorss(responseJSON) }
        }
    } catch (error) {
        dispatch(dataFetchingFinish())

        return { textNavigate: '', isSuccessful: false, textNotification: getErrorss("error") }
    }

}